module.exports = __webpack_public_path__ + "static/img/yl.afe1b4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因调控/基因编辑/yl.png
// module id = /MzM
// module chunks = 1